<script>
  export let reviewrating
  export let starColor
  export let fontSize = 18
</script>

<style>
  .default-star {
    color: #e3c90b;
  }

  .star_icon::before {
    content: '\e800';
  }

  .empty_star_icon::before {
    content: '\e801';
  }

  .kudobuzz_half_filled_star_icon::before {
    content: '\e823';
  }

  .default-star span {
    display: inline-block;
  }
</style>

{#if reviewrating > 0}
  <div
    aria-label={`${reviewrating} stars`}
    class="default-star"
    style="color: {starColor}; font-size: {fontSize}px;">
    <span
      class="kudobuzz_icons {reviewrating > 0 ? (reviewrating < 1 ? 'kudobuzz_half_filled_star_icon' : 'star_icon') : 'empty_star_icon'}
      " />
    <span
      class="kudobuzz_icons {reviewrating > 1 ? (reviewrating < 2 ? 'kudobuzz_half_filled_star_icon' : 'star_icon') : 'empty_star_icon'}
      " />
    <span
      class="kudobuzz_icons {reviewrating > 2 ? (reviewrating < 3 ? 'kudobuzz_half_filled_star_icon' : 'star_icon') : 'empty_star_icon'}
      " />
    <span
      class="kudobuzz_icons {reviewrating > 3 ? (reviewrating < 4 ? 'kudobuzz_half_filled_star_icon' : 'star_icon') : 'empty_star_icon'}
      " />
    <span
      class="kudobuzz_icons {reviewrating > 4 ? (reviewrating < 5 ? 'kudobuzz_half_filled_star_icon' : 'star_icon') : 'empty_star_icon'}
      " />
  </div>
{/if}
